/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router";
import { Footer, Header, Sidebar, Modal } from "../../components/templates";
import AppBreadcrumb from "../../components/molecules/AppBreadcrumb";
import GlobalLoader from "../../components/molecules/GlobalLoader/index";
import * as styles from "./index.styles";

const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const [showInactiveModal, setShowInactiveModal] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const resetTimer = () => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        setShowInactiveModal(true);
      }, 1000 * 60 * 20);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    resetTimer();

    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
    };
  }, []);

  const refreshPage = () => {
    window.location.reload();
  };

  const goToLogin = () => {
    navigate("/login");
  };

  return (
    <div css={styles.root}>
      <Modal
        show={showInactiveModal}
        title="Sesión inactiva"
        text="Tu sesión lleva un tiempo inactiva. Para cargar correctamente los datos, por favor refresca la página o inicia sesión nuevamente."
        btnSuccess="Refrescar página"
        btnWarning="Iniciar sesión"
        onClickSuccess={refreshPage}
        onClickWarning={goToLogin}
        onClickClose={() => setShowInactiveModal(false)}
      />

      <Sidebar />

      <div css={styles.main}>
        <Header />
        <GlobalLoader />

        <div css={styles.content}>
          <AppBreadcrumb />
          <Outlet />
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;